import service from "@/store/services/establishment-internal-orders-service";

export const state = () => ({
  list: {},
  order: {},
  meta: {},
  dailyPreparations: { date: null, orders: [], products: [], total: 0 },
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, order) => {
    state.order = order;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_DAILY_PREPARATIONS: (state, payload) => {
    state.dailyPreparations = payload;
  },
};

export const actions = {
  list({ commit }, params = {}) {
    return service.list(params).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },
  get({ commit }, params) {
    return service.get(params).then((order) => {
      commit("SET_RESOURCE", order);
    });
  },
  add({ commit }, params) {
    return service.add(params).then((order) => {
      commit("SET_RESOURCE", order);
    });
  },
  update({ commit }, params) {
    return service.update(params).then((order) => {
      commit("SET_RESOURCE", order);
    });
  },
  destroy(_ctx, params) {
    return service.destroy(params);
  },
  validate({ commit }, params) {
    return service.validate(params).then((order) => {
      commit("SET_RESOURCE", order);
    });
  },
  accept({ commit }, params) {
    return service.accept(params).then((order) => {
      commit("SET_RESOURCE", order);
    });
  },
  reject({ commit }, params) {
    return service.reject(params).then((order) => {
      commit("SET_RESOURCE", order);
    });
  },
  cancel({ commit }, params) {
    return service.cancel(params).then((order) => {
      commit("SET_RESOURCE", order);
    });
  },
  revertToDraft({ commit }, params) {
    return service.revertToDraft(params).then((order) => {
      commit("SET_RESOURCE", order);
    });
  },
  print(_ctx, params) {
    return service.print(params);
  },
  sendMail(_ctx, params) {
    return service.sendMail(params);
  },
  generateInternalInvoice(_ctx, params) {
    return service.generateInternalInvoice(params);
  },
  dailyPreparations({ commit }, params) {
    return service.dailyPreparations(params).then((payload) => {
      commit("SET_DAILY_PREPARATIONS", payload);
      return payload;
    });
  },
  weeklyPreparations(context, params) {
    return service.weeklyPreparations(params);
  },
  printPreparations(context, params) {
    return service.printPreparations(params);
  },
};

export const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.page?.total,
  order: (state) => state.order,
  dailyPreparations: (state) => state.dailyPreparations,
};

const module = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default module;
